import type { MetaDescriptor } from 'react-router'

export const PHOTO_BOOKS_DESCRIPTION =
  "Transform your favorite photos into hardcover, premium photo books you'll be proud to display. Printed at the highest quality on silk pages, they arrive quickly and make unforgettable gifts for any occasion."

export const PHOTO_BOOKS_TITLE =
  'Mixtiles Photo Books - Turn your memories into premium coffee-table books'

export const PHOTO_BOOKS_PREVIEW_IMAGE =
  'https://www.mixtiles.com/preview-photobooks-v2.jpg'

export function getTitleMetaTags(title: string): MetaDescriptor[] {
  return [
    { title },
    { property: 'og:title', content: title },
    { property: 'twitter:title', content: title },
  ]
}

export function getDescriptionMetaTags(description: string): MetaDescriptor[] {
  return [
    { name: 'description', content: description },
    { property: 'og:description', content: description },
    { property: 'twitter:description', content: description },
  ]
}

export function getImageMetaTags(image: string): MetaDescriptor[] {
  return [{ property: 'og:image', content: image }]
}
